import type { FlexContainerTextProps } from "./flex-container-text.type";

import { Typography } from "antd";

import FlexContainer from "../flex-container.component";

const { Text } = Typography;

const FlexContainerText = ({
  value,
  ...containerProps
}: FlexContainerTextProps) => (
  <FlexContainer
    {...containerProps}
    value={value ? <Text>{value}</Text> : undefined}
  />
);

export default FlexContainerText;
